export default __webpack_public_path__ + "static/media/errorimage.138ae9d4.png";